exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg[data-v-32b79688] {\n  width: 30px;\n  height: 30px;\n  -o-object-fit: contain;\n     object-fit: contain;\n  padding: 1px;\n}\n.custom-size[data-v-32b79688] {\n  font-size: 1.7rem;\n}\n", ""]);

// exports
